import { Flex } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

const Header: FCWithChildren = (props) => {
  return (
    <Flex
      borderBottom="1px solid"
      borderColor="grey.300"
      borderTopRadius="radius-8"
      gap="space-24"
      paddingX="space-16"
      paddingY="space-12"
      {...props}
    />
  );
};

export default Header;
